import { IgAccount, IgMedia, IgMediaTime } from '@core/models/ApiFields/ig-entities';
import { TimeFields } from '@core/models/ApiFields/time-fields.enums';
import { Dimension } from '@features/social-analysis/models/IDimensions';
import { deepcopy } from '@shared/utils/Objects';
import { accountMetrics, insightsDims, insightsMetrics, mediaMetrics } from './insights';
import { COMPONENTS_ENUM } from './page';

const sentimentMetrics = [
    {
        display: 'Captions negativity',
        value: IgMedia.getPrefixed('captionsNegativity'),
        prefix: IgMedia.prefix,
    },
    {
        display: 'Captions positivity',
        value: IgMedia.getPrefixed('captionsPositivity'),
        prefix: IgMedia.prefix,
    },
    {
        display: 'Comments negativity',
        value: IgMediaTime.getPrefixed('commentsNegativity'),
        prefix: IgMediaTime.prefix,
    },
    {
        display: 'Comments positivity',
        value: IgMediaTime.getPrefixed('commentsPositivity'),
        prefix: IgMediaTime.prefix,
    },
];

const getMetrics = () => {
    const mediaMetricsCopy = deepcopy(mediaMetrics);
    mediaMetricsCopy.values.unshift(...sentimentMetrics);
    return [mediaMetricsCopy, accountMetrics];
};

export const initDim = insightsDims
    .flatMap(categ => categ.values)
    .find(opt => opt.value === TimeFields.date) as Dimension;

export const fixedDim = insightsDims
    .flatMap(categ => categ.values)
    .find(opt => opt.value === IgAccount.getPrefixed('igAccount')) as Dimension;

export const getInitDimension = () => [fixedDim, initDim];

export const getInitMetrics = () => [
    insightsMetrics
        .flatMap(categ => categ.values)
        .find(opt => opt.value === IgMediaTime.getPrefixed('likes')) as Dimension,
];

export const insightsChartInit = {
    component: COMPONENTS_ENUM.CHART,
    dimOpts: insightsDims,
    metricOpts: getMetrics(),
    fixedDim: fixedDim,
    maxMetrics: 1,
    dimension: getInitDimension(),
    metrics: getInitMetrics(),
};
